import { createContext, useContext, useEffect, useRef, useState } from "react"
import { access, isDef } from "./general";
import $, {  } from 'jquery';


var debugCheck = "nav"; //1_3657

export function makeStore(state){

    state = state?state:{};

    const setters = new Map();
    const weakSets = new WeakMap();

    return {
        state : state,
        
        useSelector : function ( selector , resetContext ) {

            var resetRef = useRef(resetContext);
            var [value,setState] = useState(()=>selector(state));

            if (resetRef.current != resetContext){
                setState(selector(state));
                resetRef.current = resetContext
            }

            if ( resetContext == debugCheck ) {
                var ii = 0;
            }

            // clear any existing setter associated with this setState
            var existingSetter = weakSets.get(setState);
            if (existingSetter){
                setters.delete(existingSetter);
            }

            var weakSet = eval("new WeakRef(setState)");

            var setter = () => {
                var set = weakSet.deref();
                if (set) {
                    var newValue = selector(state);
                    if (resetContext==debugCheck){
                        var ii = 0;
                    }
                    set(newValue);
                }
                return !!set;
            };

            setters.set(setter,setter);     // store the setter so it can be called in dispatch()
            
            weakSets.set(setState,setter);  // record the setter which refers to the setState so it can be deleted when the same setState is found
            setState = null;              // clear reference to setState so it can be garbage collected
            
            // var numberOfSetters = 0;
            // for  (let [key, setter] of setters) {
            //     numberOfSetters++;
            // }
            // console.log ("Setter count : "+ numberOfSetters)
            return value;
        },

        dispatch : function (verb,context){

            if (typeof verb == 'string'){
                state[verb].apply(state,[context]);
            } else {
                verb(state,context);            
            }

            var weekSettersToRemove = [];
            
            for  (let [key, setter] of setters) {
                if (!setter()){
                    weekSettersToRemove.push(key);
                }
            }

            $.each(weekSettersToRemove,(s,key)=>{
                setters.delete(key);
            })
            
        },

        access : function (path){
            return access(state,path)
        }

    }

}

